// HeavyContent.jsx

import React, { useRef, useEffect } from 'react';
import { useGLTF, useAnimations } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

export default function HeavyContent({ waterRef, grassRef, iceGroundRef, synthwaveMode }) {
  // You know what, I've changed these so many times, I'm done refactoring the names. Good luck future me. Random nums it is
  const waterSurface = useGLTF('./1kites_in_clouds_how.glb');
  const grass = useGLTF('./1grass.glb');
  const iceGround = useGLTF('./low_poly_mountain_scene.glb');
  const three = useGLTF('./three.glb');
  const four = useGLTF('./four.glb');
  const five = useGLTF('./fivee.glb');
  const pusheen = useGLTF('./1_pusheen.glb');
  const dtt = useGLTF('./dtt.glb');
  const mon = useGLTF('./mon.glb');
  const station = useGLTF('./station.glb');

  const { animations: waterAnimations } = waterSurface;
  const { animations: grassAnimations } = grass;

  const waterMixerRef = useRef();
  const grassMixerRef = useRef();

  useAnimations(waterAnimations, waterRef);
  useAnimations(grassAnimations, grassRef);

  useEffect(() => {
    waterMixerRef.current = new THREE.AnimationMixer(waterRef.current);
    grassMixerRef.current = new THREE.AnimationMixer(grassRef.current);

    waterAnimations.forEach((clip) => {
      const action = waterMixerRef.current.clipAction(clip);
      action.play();
    });

    grassAnimations.forEach((clip) => {
      const action = grassMixerRef.current.clipAction(clip);
      action.play();
    });

    return () => {
      waterMixerRef.current.stopAllAction();
      grassMixerRef.current.stopAllAction();
    };
  }, [waterAnimations, grassAnimations]);

  useFrame((state, delta) => {
    if (waterMixerRef.current) {
      waterMixerRef.current.update(delta);
    }
    if (grassMixerRef.current) {
      grassMixerRef.current.update(delta);
    }
  });

  return (
    <group>
      <primitive
        ref={waterRef}
        object={waterSurface.scene}
        position={[10, 1, -5]}
        scale={[0.3, 0.25, 0.3]}
      />

      <primitive
        ref={grassRef}
        object={grass.scene}
        position={[2, -0.7, 3.2]}
        rotation={[0, 0, 0]}
        scale={[2, 2, 2]}
      />

      {/* GLB models */}
      <primitive
        object={three.scene}
        position={[-2.5, -0.71, 0.45]}
        scale={[0.03, 0.03, 0.03]}
      />
      <primitive
        object={four.scene}
        position={[2.08, -0.7, -0.5]}
        scale={[0.12, 0.12, 0.12]}
      />
      <primitive
        object={five.scene}
        position={[3.6, -0.62, -2]}
        scale={[1, 1, 1]}
        rotation={[Math.PI / 2, 0, Math.PI / 1]}
      />

      {/* New GLB models */}
      <primitive
        object={pusheen.scene}
        position={[-2.1, -0.22, -.7]}
        scale={[0.1, 0.1, 0.1]}
      />
      <primitive
        object={dtt.scene}
        position={[2.23, -0.71, 0.4]}
        scale={[0.5, 0.47, 0.5]}
      />
      <primitive
        object={mon.scene}
        position={[4.2, -0.71, -3]}
        scale={[15, 15, 15]}
        rotation={[0, -Math.PI / 2, 0]}
      />
      <primitive
        object={station.scene}
        position={[-2.2, -.71, -2.4]}
        scale={[4, 4, 4]}
      />
      <primitive
        ref={iceGroundRef}
        object={iceGround.scene}
        position={[0, -70, 0]}
        rotation={[0, -1.75, 0]}
        scale={[20, 20, 20]}
      />
    </group>
  );
}
